export interface ScoreRingProps {
  score: number;
  size?: number;
  strokeWidth?: number;
  colorScale?: 'health' | 'risk' | 'prep';
  label?: string;
}

function ringColor(score: number, scale: string): string {
  if (scale === 'risk') {
    if (score >= 70) return 'var(--danger)';
    if (score >= 40) return 'var(--warn)';
    return 'var(--success)';
  }
  if (score >= 70) return 'var(--success)';
  if (score >= 40) return 'var(--warn)';
  return 'var(--danger)';
}

export function ScoreRing({ score, size = 48, strokeWidth = 4, colorScale = 'health', label }: ScoreRingProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (Math.min(score, 100) / 100) * circumference;
  const color = ringColor(score, colorScale);
  return (
    <div
      className="relative inline-flex items-center justify-center"
      style={{ width: size, height: size }}
      role="img"
      aria-label={label ? `${label}: ${Math.round(score)} out of 100` : `Score: ${Math.round(score)} out of 100`}
    >
      <svg aria-hidden="true" width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} strokeWidth={strokeWidth} stroke="var(--surface-3)" fill="none" />
        <circle cx={size / 2} cy={size / 2} r={radius} strokeWidth={strokeWidth} stroke={color} fill="none" strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={offset} className="transition-[stroke-dashoffset] duration-700 ease-out" />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-mono font-semibold tabular-nums text-ink" style={{ fontSize: size < 40 ? '9px' : '11px' }}>{Math.round(score)}</span>
        {label && <span className="text-2xs font-medium text-ink-dim">{label}</span>}
      </div>
    </div>
  );
}
